import React, {CSSProperties} from "react";
import {BroadcastUtils, ProductData, ProductItem} from "filkersjs-model/dist";
import {Col, Row} from "reactstrap";
import {useCreation} from "ahooks";

export interface ItemDataPanelProps {
    item: ProductItem,
    size?: "large" | "small",
    style?: CSSProperties
}

const ItemDataPanel = ({item, style, size = "small"}: ItemDataPanelProps) => {

    const itemData = useCreation<ProductData>(() => {
        return BroadcastUtils.findLocalizedItemData(item);
    }, [item])

    return (
        <div className={`flk-item-data flk-item-data-${size}`} style={style}>
            <Row>
                <Col xs={12}>
                    <span className="flk-item-data-price">
                        {itemData.price === undefined ? '' : itemData.price.isoformat}
                    </span>

                    <span className="flk-item-data-original-price-wrapper">
                        <span className="flk-item-data-original-price">
                            {itemData.originalPrice === undefined ? '' : itemData.originalPrice.isoformat}
                        </span>
                    </span>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <div className="flk-item-data-title">
                        {itemData.title}
                    </div>
                </Col>
            </Row>
        </div>
    );

}

export default ItemDataPanel;
